module.exports = "::ng-deep .ai-setting-component .mat-raised-button {\n  float: right;\n}\n"